module.exports = __webpack_public_path__ + "img/odins-logo-big.7847ab9b.png";